import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { AppBar, Toolbar, Typography, makeStyles, Button } from "@material-ui/core";
import '../../../styles/navbar.scss';
import Modalpopup from '../../pages/Modalpopup/Modalpopup';
import { Link as Li } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import MenuIcon from '@material-ui/icons/Menu';
import Accordion from '@material-ui/core/Accordion';
import { split } from 'lodash';
import { useGAEventsTracker } from "../../../util/gtag";
import config from "../../config/config";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles(() => ({
    title: {
        flexGrow: 1,
    },
    header: {
        backgroundColor: '#fff',
        color: "black",
        "@media (max-width: 900px)": {
            paddingLeft: 0,
        },
    },
    logo: {
        fontFamily: "Work Sans, sans-serif",
        fontWeight: 600,
        color: "black",
        textAlign: "left",
        width: '100%',
    },
    menuButton: {
        fontWeight: 700,
        size: "18px",
        marginLeft: "38px",
    },
    toolbar: {
        display: "flex",
        justifyContent: "space-between",
    },
}));

export default function Navbar(props) {
    // const GAEventTracker = useGAEventsTracker(window.location.pathname);
    // const GAEventTrackerContact = useGAEventsTracker(window.location.pathname + "/Contact Us");
    // const GAEventTrackerHowItWorks = useGAEventsTracker(window.location.pathname + "/How It Works");
    // const GAEventTrackerFaq = useGAEventsTracker(window.location.pathname + "/FAQs")
    const location = useLocation();

    const GAEventTracker = useGAEventsTracker(location.pathname);
    const GAEventTrackerContact = useGAEventsTracker(
        `${location.pathname}/Contact Us`
    );
    const GAEventTrackerHowItWorks = useGAEventsTracker(
        `${location.pathname}/How It Works`
    );
    const GAEventTrackerFaq = useGAEventsTracker(
        `${location.pathname}/FAQs`
    );

    const history = useHistory();
    const [openSubmit, setOpenSubmit] = React.useState(false);
    const [drawerstate, setDrawerState] = useState(false)
    const handleClickOpen2 = () => {
        setOpenSubmit(!openSubmit);
    };
    const { header, logo, toolbar } = useStyles();
    const [state, setState] = useState({
        mobileView: false,
        drawerOpen: false,
    });
    const { mobileView } = state;
    const handleHome = () => {
        setTimeout(() => {
            setDrawerState(!drawerstate)
        }, 100)
    }
    const menuClicked = (e) => {
        e.stopPropagation()
    }
    const handleMobileMenu = (event, state) => {
        event.stopPropagation();
        setDrawerState(state);
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
    };
    const handleFaqMobile = () => {
        setDrawerState(!drawerstate);
        const url = window.location.href;
        const urlName = new URL(url);
        const urlNamePath = split(urlName.pathname, "/")
        if (urlNamePath[3] === "calculator") {
            history.push(`/lender/${props?.partner?.url_path}`)
            setTimeout(() => {
                let ele = document.getElementById('faq')
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }, 200);
        }
    }
    const handleHowItWorks = () => {
        setDrawerState(!drawerstate)
        const url = window.location.href;
        const urlName = new URL(url);
        const urlNamePath = split(urlName.pathname, "/")
        if (urlNamePath[3] === "calculator") {
            history.push(`/lender/${props?.partner?.url_path}`)
            setTimeout(() => {
                let ele = document.getElementById('trade')
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
            }, 200);
        }
    }
    const handleDesktopHowItWorks = () => {
        const url = window.location.href;
        const urlName = new URL(url);
        const urlNamePath = split(urlName.pathname, "/")
        if (urlNamePath[3] === "calculator") {
            history.push(`/lender/${props?.partner?.url_path}`)
            setTimeout(() => {
                let ele = document.getElementById('trade')
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
            }, 200);
        }
    }
    const handleDesktopFaq = () => {
        const url = window.location.href;
        const urlName = new URL(url);
        const urlNamePath = split(urlName.pathname, "/")
        if (urlNamePath[3] === "calculator") {
            history.push(`/lender/${props?.partner?.url_path}`)
            setTimeout(() => {
                let ele = document.getElementById('faq')
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }, 200);
        }
    }

    const handleCalculator = () => {
        const currentURL = window.location.href;
        const urlObj = new URL(currentURL);
        const pathSegments = urlObj.pathname.split('/');
        const isCalculator = pathSegments.includes('lender');
        const isBuilderCalculator = pathSegments.includes('builder-calculator');
        if(isCalculator) {
            history.push(`/lender/${props?.partner?.url_path}/calculator`);
        } else if(isBuilderCalculator) {
            history.push(`/builder-calculator`);
        } else {
            history.push(`/builder/${props?.partner?.url_path}/calculator`);
        } 
          
    }
    const mobileNav = () => {
        return (
            <>
                <div className="partner_navbar_mob">
                    <div>
                        {props?.pathname && props?.pathname.length !== 0 ?
                            (props?.partner?.url_path === 'hometown') ?
                                <div className="partner_navbar_sub_mob">
                                    <div><img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '120px', height: '68px', objectFit: 'contain' }}></img></div>
                                    <div className="px-2 partner_header_plus mt-3">+</div>
                                    <div className="partner_header_logo_calque">
                                        <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                            <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="142px" height="45px" className="mt-3"></img>
                                        </Li>
                                    </div>
                                </div>

                                : props?.partner?.url_path === 'nrl' || props?.partner?.url_path === 'firstfederal' ? (
                                    <div className="partner_navbar_sub_mob">
                                    <div><img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '110px', height: '50px', objectFit: 'contain' }}></img></div>
                                    <div className="px-2 partner_header_plus mt-3">+</div>
                                    <div className="partner_header_logo_calque">
                                        <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                            <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="140px" height="42px" className="mt-3"></img>
                                        </Li>
                                    </div>
                                </div>
                                ):
                                props?.pathname?.url_path === 'teamnikkijames' ?
                                    <div className="partner_navbar_sub_mob">
                                        <div><img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '120px', height: '68px', objectFit: 'contain' }}></img></div>
                                        <div className="px-2 partner_header_plus mt-1">+</div>
                                        <div className="partner_header_logo_calque">
                                            <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                                <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="98px" height="35px" className="mt-1"></img>
                                            </Li>
                                        </div>
                                    </div>
                                    :
                                    props?.partner?.url_path === 'gvc'?
                                        <div className="partner_navbar_sub_mob">
                                            <div style={{ display:"flex", height:"35px" }}>
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '150px', height: '80px',  objectFit: 'contain', paddingBottom: '50px', }}></img>
                                            </div>
                                            <div className="px-2 partner_header_plus mt-1">+</div>
                                            <div className="partner_header_logo_calque">
                                                <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                                    <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="98px" height="35px" className="mt-1"></img>
                                                </Li>
                                            </div>
                                        </div>
                                    :props?.partner?.url_path === 'rvwarburton'?
                                        <div className="partner_navbar_sub_mob">
                                            <div style={{ display:"flex", height:"35px" }}>
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '40px', height: '90px',  objectFit: 'contain', paddingBottom: '50px', }}></img>
                                            </div>
                                            <div className="px-2 partner_header_plus mt-1">+</div>
                                            <div style={{ display:"flex", height:"35px" }}>
                                                <img src="/assets/partner_logos/Warburton.png" alt="Logo" className="" style={{ width: '66px', height: '36px',  objectFit: 'contain' }}></img>
                                            </div>
                                            <div className="px-2 partner_header_plus mt-1">+</div>
                                            <div className="partner_header_logo_calque">
                                                <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                                    <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="98px" height="35px" className="mt-1"></img>
                                                </Li>
                                            </div>
                                        </div>
                                    :
                                    <div className="partner_navbar_sub_mob">
                                        <div><img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '120px', height: '68px', objectFit: 'contain' }}></img></div>
                                        <div className="px-2 partner_header_plus">+</div>
                                        <div className="partner_header_logo_calque">
                                            <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                                <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="142px" height="45px"></img>
                                            </Li>
                                        </div>
                                    </div>
                            :
                            ''}
                    </div>
                    <div>
                        <div onClick={(e) => handleMobileMenu(e, !drawerstate)} onKeyDown={(e) => handleMobileMenu(e, !drawerstate)} style={{ cursor: 'pointer' }} className="d-flex align-items-center justify-content-center">
                            <MenuIcon />
                        </div>
                    </div>
                </div>
                {drawerstate === true ?
                    props?.partner?.url_path === 'test' ? 
                    <div id="mobilemenu" style={{ position: 'absolute', width: '100%', backgroundColor: '#fff', top: '3.5rem', borderTop: '1px solid #eee' }} onClick={menuClicked}>
                    <div id="menuAccordian">
                        <Accordion className="p-2 pl-4">
                            <Li activeclass="active"
                                to={`/lender/${props?.partner?.url_path}`}
                                href={`/lender/${props?.partner?.url_path}`}
                                onClick={(e) => { GAEventTracker("Home"); handleHome() }}
                                spy={true}
                                smooth="true"
                                offset={-70}
                                className={props?.partner?.url_path === "c2" ? "ftpolar-semibold" :""}
                                duration={500}>
                                Home
                            </Li>
                        </Accordion>
                        <Accordion className="p-2 pl-4">
                            <Link activeclass="active"
                                to="trade"
                                spy={true}
                                smooth="true"
                                offset={-70}
                                onClick={(e) => { GAEventTrackerHowItWorks("Header", 1); handleHowItWorks() }}
                                className={props?.partner?.url_path === "c2" ? "ftpolar-semibold" : ""}
                                duration={500}>
                                How It Works
                            </Link>
                        </Accordion>

                        <Accordion className="p-2 pl-4">
                            <Link activeclass="active"
                                className={props?.partner?.url_path === "c2" ? "ftpolar-semibold faqs" : "faqs"}
                                to="faq"
                                spy={true}
                                smooth="true"
                                offset={-70}
                                duration={500}
                                onClick={(e) => { GAEventTrackerFaq("Header", 1); handleFaqMobile() }}
                            >
                                FAQs
                            </Link>
                        </Accordion>
                        <Accordion className="p-2 pl-4">
                            <Li activeclass="active"
                                onClick={(e) => { GAEventTrackerContact("Contact Us", 1); handleClickOpen2() }}
                                className={props?.partner?.url_path === "c2" ? "ftpolar-semibold" :""}
                            >
                                Contact
                            </Li>
                        </Accordion>
                    </div>
                </div> :
                <div id="mobilemenu" style={{ position: 'absolute', width: '100%', backgroundColor: '#fff', top: '3.5rem', borderTop: '1px solid #eee' }} onClick={menuClicked}>
                    <div id="menuAccordian">
                    <Accordion className="p-2 pl-4">
                        <Li activeclass="active"
                            to={`/lender/${props?.partner?.url_path}`}
                            href={`/lender/${props?.partner?.url_path}`}
                            onClick={(e) => { GAEventTracker("Home"); handleHome() }}
                            spy={true}
                            smooth="true"
                            offset={-70}
                            className={props?.partner?.url_path === "c2" ? "ftpolar-semibold" :""}
                            duration={500}>
                            Home
                        </Li>
                    </Accordion>
                    <Accordion className="p-2 pl-4">
                        <Link activeclass="active"
                            to="trade"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerHowItWorks("Header", 1); handleHowItWorks() }}
                            className={props?.partner?.url_path === "c2" ? "ftpolar-semibold" : ""}
                            duration={500}>
                            How It Works
                        </Link>
                    </Accordion>

                    <Accordion className="p-2 pl-4">
                        <Link activeclass="active"
                            className={props?.partner?.url_path === "c2" ? "ftpolar-semibold faqs" : "faqs"}
                            to="faq"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            duration={500}
                            onClick={(e) => { GAEventTrackerFaq("Header", 1); handleFaqMobile() }}
                        >
                            FAQs
                        </Link>
                    </Accordion>
                    {/* <Accordion className="p-2 pl-4">
                        <Link activeclass="active"
                            className={props?.partner?.url_path === "c2" ? "ftpolar-semibold faqs" : "faqs"}
                            // to="/calculator"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            duration={500}
                            onClick={(e) => { handleCalculator() }}
                        >
                            Calculator
                        </Link>
                    </Accordion> */}
                    <Accordion className="p-2 pl-4">
                        <Li activeclass="active"
                            onClick={(e) => { GAEventTrackerContact("Contact Us", 1); handleClickOpen2() }}
                            className={props?.partner?.url_path === "c2" ? "ftpolar-semibold" :""}
                        >
                            Contact
                        </Li>
                    </Accordion>
                </div>
            </div>
                    : ''
                }
            </>
        )
    };

    const desktopNav = () => {
        return (
            <Toolbar className={toolbar}>
                { props?.partner?.url_path === "test" ? 
                <>
                <div className="col-7 jost-bold" >
                    <Typography variant="h6" component="h1" className={logo}>
                        <div className="login_img d-flex align-items-center justify-content-start">
                            {props.pathname && props.pathname.length !== 0 ?
                                <>
                                    <Li to={`/lender/${props?.partner?.url_path}`} style={props?.partner?.url_path === 'gvc'? {display:"flex"}:{}} onClick={(e) => { GAEventTracker("Home") }}>        
                                        <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '110px', height: '68px', objectFit: 'contain', }}></img>   
                                    </Li>
                                    <p className="px-2 m-0">+</p>
                                </>
                                : ''
                            }
                            <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="142px" height="45px"></img>
                            </Li>
                        </div>
                    </Typography>
                </div>
                <div className="col-5 d-flex justify-content-end align-items-center jost-bold ipad-res" >
                    <div className="w-100 d-flex justify-content-between align-items-center global-nav">
                        <Link activeclass="active"
                            className="NavHeader"
                            to="trade"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerHowItWorks("Header", 1); handleDesktopHowItWorks() }}
                            duration={500}>
                            WHY WORK WITH US?
                        </Link>
                        <Link activeclass="active"
                            className="NavHeader"
                            to="trade"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerHowItWorks("Header", 1); handleDesktopHowItWorks() }}
                            duration={500}>
                            HOW IT WORKS
                        </Link>
                        <Link activeclass="active"
                            className="faqs"
                            to="faq"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerFaq("Header", 1); handleDesktopFaq() }}
                            duration={500}>
                            FAQs
                        </Link>
                        <Button
                            variant="contained"
                            disableelevation="true"
                            onClick={(e) => { GAEventTrackerContact("Contact Us", 1); handleClickOpen2() }}
                            style={{ color: 'white', backgroundColor: `${props.partner && props.partner.secondary_color ? props.partner.secondary_color : '#2A83C2'}` }}
                        >
                            Contact
                        </Button>
                    </div>
                </div>
                </> :
                <>
                <div className="col-7 jost-bold" >
                    <Typography variant="h6" component="h1" className={logo}>
                        <div className="login_img d-flex align-items-center justify-content-start">
                            {props.pathname && props.pathname.length !== 0 ?
                                <>
                                    <Li to={`/lender/${props?.partner?.url_path}`} style={props?.partner?.url_path === 'gvc'? {display:"flex"}:{}} onClick={(e) => { GAEventTracker("Home") }}>
                                        {
                                            props?.partner?.url_path === 'teamnikkijames' ? (
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '190px', height: '68px', objectFit: 'contain', }}></img>

                                            ) : props?.partner?.url_path === 'nrl' || props?.partner?.url_path === 'firstfederal'? (

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '110px', height: '50px', objectFit: 'contain', }}></img>
                                            ) : props?.partner?.url_path === 'aslan' ?(

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '126px', height: '52px', objectFit: 'contain', }}></img>

                                            ) : props?.partner?.url_path === 'revest' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '80px', height: '80px', objectFit: 'contain', }}></img>

                                            :  props?.partner?.url_path === 'haus' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '85px', height: '85px', objectFit: 'contain', }}></img>
                                            
                                            :  props?.partner?.url_path === 'waymaker' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '130px', height: '75px', objectFit: 'contain', }}></img>
                                        
                                            :   props?.partner?.url_path === 'fairway' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '148px', height: '68px', objectFit: 'contain', }}></img>
                                    
                                            :   props?.partner?.url_path === 'cornerstone' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '130px', height: '67px', objectFit: 'contain', }}></img>
                                            
                                            :   props?.partner?.url_path === 'junodteam' || props?.partner?.url_path === 'harboronemortgage' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '166px', height: '67px', objectFit: 'contain', }}></img>
                                        
                                            :   props?.partner?.url_path === 'rapid' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '150px', height: '74px', objectFit: 'contain', }}></img>
                                        
                                            :   props?.partner?.url_path === 'sammamish' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '144px', height: '68px', objectFit: 'contain', }}></img>
                                        
                                            :  props?.partner?.url_path === 'oxford' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '86px', height: '43px', objectFit: 'contain', }}></img>
                                            
                                            :   props?.partner?.url_path === 'usmortgage' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '188px', height: '75px', objectFit: 'contain', }}></img>
                                            
                                            :   props?.partner?.url_path === 'homesouth' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '72px', height: '82px', objectFit: 'contain', }}></img>
                                            
                                            :   props?.partner?.url_path === 'rivercity' ?

                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '150px', height: '68px', objectFit: 'contain', }}></img>
                                        
                                            :    props?.partner?.url_path === 'gvc' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '190px', height: '80px',  objectFit: 'contain', marginBottom: '10px' }}></img>
                                        
                                            :    props?.partner?.url_path === 'ideal' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '180px', height: '80px',  objectFit: 'contain', marginBottom: '10px', paddingTop: '5px' }}></img>
                                        
                                            :    props?.partner?.url_path === 'fidelity' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '80px', height: '68px',  objectFit: 'contain'}}></img>
                                        
                                            :    props?.partner?.url_path === 'james' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '145px', height: '68px',  objectFit: 'contain'}}></img>
                                    
                                            :   props?.partner?.url_path === 'interconnect' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '143px', height: '70px',  objectFit: 'contain'}}></img>

                                            :   props?.partner?.url_path === 'platte' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '170px', height: '90px',  objectFit: 'contain', paddingBottom: '10px'}}></img>

                                            :   props?.partner?.url_path === 'bayshore' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '150px', height: '71px',  objectFit: 'contain'}}></img>
                                            
                                            :   props?.partner?.url_path === 'mustache' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '80px', height: '90px',  objectFit: 'contain' }}></img>

                                            :   props?.partner?.url_path === 'newcastle' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '90px', height: '90px',  objectFit: 'contain' }}></img>
                                                
                                            :   props?.partner?.url_path === 'mortgagetrust' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '210px', height: '75px',  objectFit: 'contain', paddingBottom: '8px' }}></img>
                                                
                                            :   props?.partner?.url_path === 'midflorida' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '120px', height: '62px',  objectFit: 'contain', paddingBottom: '8px' }}></img>
                                            
                                            :   props?.partner?.url_path === 'financialdwellings' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '126px', height: '72px',  objectFit: 'contain', paddingBottom: '8px' }}></img>
                                        
                                            :   props?.partner?.url_path === 'nest' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '126px', height: '81px',  objectFit: 'contain', padding: '2px 0px' }}></img>
                                    
                                            :   props?.partner?.url_path === 'sifi' ?
                                                
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '148px', height: '68px',  objectFit: 'contain' }}></img>
                                
                                            :   props?.partner?.url_path === 'rvwarburton' ?
                                                <span style={{display:'flex',alignItems:'center',justifyContent:'center'}} className="custom-partner-navbar">
                                                    <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '80px', height: '60px',  objectFit: 'contain' }}></img>
                                                    <p className="px-2 m-0" style={{color:'black'}}> + </p>
                                                    <img src="/assets/partner_logos/Warburton.png" alt="Logo"  style={{ width: '90px', height: '60px',  objectFit: 'contain' }}></img>
                                                </span>
                                            :
                                            (
                                                <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '110px', height: '68px', objectFit: 'contain', }}></img>
                                            )
                                        }
                                    </Li>
                                    {props?.partner?.url_path === 'hometown' ?
                                        (
                                            <p className="px-2 m-0 mt-3">+</p>
                                        ) : 
                                    props?.partner?.url_path === 'bayshore' ?
                                        (
                                            <p className="px-3 m-0">+</p>
                                        ) :     
                                    props?.partner?.url_path === 'newcastle' ?
                                        (
                                            <p className="px-3 m-0">+</p>
                                        ) : 
                                    props?.partner?.url_path === 'gvc' ?
                                        (
                                            <p className="px-2 m-1">+</p>
                                        )
                                        :
                                        (
                                            <p className="px-2 m-0">+</p>
                                        )
                                    }
                                </>
                                : ''
                            }
                            {props?.pathname?.url_path === "hometown" ? (
                                <Li className="mt-1" to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                    <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="142px" height="45px"></img>
                                </Li>

                            ) : props?.pathname?.url_path === "nrl" || props?.partner?.url_path === 'firstfederal' ?(

                                <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="142px" height="45px"></img>
                            </Li>
                            ) : props?.pathname?.url_path === "newcastle" ?(

                                <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="142px" height="45px"></img>
                            </Li>
                            ) : (
                                <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                    <img src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp" alt="Logo" width="142px" height="45px"></img>
                                </Li>
                            )}
                        </div>
                    </Typography>
                </div>
                <div className="col-5 d-flex justify-content-end align-items-center jost-bold ipad-res" >
                    <div className="w-100 d-flex justify-content-between align-items-center global-nav">
                        <Link activeclass="active"
                            className={props?.partner?.url_path === "c2" ? "ftpolar-semibold NavHeader" : "NavHeader"}
                            to="trade"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerHowItWorks("Header", 1); handleDesktopHowItWorks() }}
                            duration={500}>
                            HOW IT WORKS
                        </Link>
                        <Link activeclass="active"
                            className={props?.partner?.url_path === "c2" ? "ftpolar-semibold faqs" : "faqs"}
                            to="faq"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerFaq("Header", 1); handleDesktopFaq() }}
                            duration={500}>
                            FAQs
                        </Link>
                        {/* <Link activeclass="active"
                            className={props?.partner?.url_path === "c2" ? "ftpolar-semibold faqs" : "faqs"}
                            //to="/calculator"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { handleCalculator() }}
                            duration={500}>
                            CALCULATOR
                        </Link> */}
                        <Button
                            variant="contained"
                            disableelevation="true"
                            onClick={(e) => { GAEventTrackerContact("Contact Us", 1); handleClickOpen2() }}
                            style={{ color: 'white', backgroundColor: `${props.partner && props.partner.secondary_color ? props.partner.secondary_color : '#2A83C2'}` }}
                        >
                            Contact
                        </Button>
                    </div>
                </div>
                </> }
            </Toolbar>
        )
    }

    useEffect(() => {
        document.addEventListener('click', function (e) {
            setDrawerState(false)
        });
    })

    useEffect(() => {
        const setResponsiveness = () => {
            return window.innerWidth < 770
                ? setState((prevState) => ({ ...prevState, mobileView: true }))
                : setState((prevState) => ({ ...prevState, mobileView: false }));
        };
        setResponsiveness();
        window.addEventListener("resize", () => setResponsiveness());
    }, []);

    function Contactus() {
        return (
            <>
                <div className="container-fluid m-0 top-padding-small bottom-padding-main px-md-5">
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5" style={props?.partner?.url_path === "hma"? {padding:"0px"}:{}}>
                            <div className="justify-content-md-between align-items-md-center">
                                <h3 className={props?.partner?.url_path === "c2" ? "ftpolar-semibold headerfont" : "headerfont"}>Contact Us</h3>
                                {props?.partner?.url_path === "hma" ? <><div className="contentfonthead">To speak with an HMA Mortgage representative, call <div className="contentfont" style={{ color: 'black' , fontWeight:"600"}}>888-HMA-1080</div></div>
                                <div className="contentfonthead">Or send an email to <div className="contentfont hma-font" style={{ color: 'black' , fontWeight:"600"}}>TradeInMortgage@HMAmortgage.com</div></div></>:
                                <>
                                <div className={props?.partner?.url_path === "c2" ? "ftpolar-light contentfonthead":"contentfonthead"}>To speak with a Calque representative, call</div>
                                <div className={props?.partner?.url_path === "c2" ? "ftpolar-semibold contentfont" :"contentfont"}>
                                    <a className="tel" href={`tel:${props?.contactGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.contactGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className={props?.partner?.url_path === "c2" ? "ftpolar-light contentfonthead":"contentfonthead"}>Or send an email to</div>
                                <div className={props?.partner?.url_path === "c2" ? "ftpolar-semibold contentfont":"contentfont"}>
                                    <a className="mailto" href={`mailto:${props?.emailGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.emailGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className={props?.partner?.url_path === "c2" ? "ftpolar-light contentfonthead":"contentfonthead"}>Our address is</div>
                                <div className={props?.partner?.url_path === "c2" ? "ftpolar-semibold contentfont":"contentfont"}>
                                    <b>
                                        <p className="contactAddress">
                                            {props?.addressGlobal?.application_config_value}
                                        </p>
                                    </b>
                                </div></>}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <AppBar className={header}>
            {mobileView ? mobileNav() : desktopNav()}
            <Modalpopup partner={props?.partner?.url_path} logo={props?.partner?.logo} open={openSubmit} handleClickOpen={handleClickOpen2} contact={Contactus()} />
        </AppBar>
    );
}